import type { NewsQueryResponse, QueryResponse, RoposoQueryResponse } from '$lib/types/query';
import { CDS_API_ENDPOINT } from '../endpoints';
import { getHeaders } from '../headers';
import { post } from '../requester';
//import { generateMD5Hash } from '$lib/utils';
const config = {
  headers: getHeaders()
};

export const fetchQuery = (query: string): Promise<QueryResponse> => {
  const endpoint = CDS_API_ENDPOINT;
  const body = {
    namespace: 'tf_portal',
    params: {
      graphQLQuery: query
    },
    queryId: 'contentful_pass_through'
  };
  //const endpointWithHash = `${endpoint}?cacheKey=${generateMD5Hash(JSON.stringify(body))}`;

  return post(endpoint, body, config);
};

export const fetchNewsQuery = (
  params: Record<string, string | string[] | number>
): Promise<NewsQueryResponse> => {
  const endpoint = CDS_API_ENDPOINT;
  const body = {
    language: 'EN-US',
    namespace: 'tf_portal',
    params,
    queryId: 'swish_news_1'
  };
  return post(endpoint, body, config);
};

export const fetchRoposoQuery = (query: string): Promise<RoposoQueryResponse> => {
  const endpoint = CDS_API_ENDPOINT;
  const body = {
    namespace: 'tf_portal',
    params: {
      graphQLQuery: query
    },
    queryId: 'contentful_pass_through'
  };
  return post(endpoint, body, config);
};
